<template>
	<label :for="forId" :class="['eb-input-label', helpText ? 'eb-input-label-helpText' : null]">
		<slot v-if="labelAfter" />
		
		<span v-if="required" class="eb-input-label-mandatory-icon"><i class="fa fa-solid fa-asterisk"></i></span>
		
		<span v-if="required">{{ text }} (obligatoire)</span>
		<span v-else>{{ text }}</span>
		
		<span v-if="infoIcon" class="eb-input-label-helpText-icon"><i class="fa fa-solid fa-info-circle"></i></span>
		<span v-if="helpText" class="eb-input-label-helpText-text">{{ helpText }}</span>
		
		<slot v-if="!labelAfter" />
	</label>
</template>

<script>
/**
* Form Inputs labels.
*/
export default {
	name: "EbLabel",
	status: "ready",
	release: "1.0.0",
	props: {
		forId: {
			type: String,
			default: null,
		},
		required: {
			type: Boolean,
			default: false,
		},
		infoIcon: {
			type: Boolean,
			default: false,
		},
		helpText: {
			type: String,
			default: null,
		},
		text: {
			type: String,
			required: true,
		},
		labelAfter: {
			type: Boolean,
			default: false,
		},
	},
}
</script>

<style lang="scss" scoped>
.eb-input-label {
	cursor: pointer;
	@include stack-space($eb-space-default);
	
	&-mandatory {
		&-icon {
			color: $eb-color-error;
			margin-right: $eb-space-xs;
			font-size: 50%;
			top: -$eb-space-s;
			position: relative;
		}
	}
	
	&-helpText {
		label {
			@include stack-space($eb-space-xs);
		}
		&-icon {
			margin-left: $eb-space-xs;
		}
		&-text {
			font-style: italic;
			font-size: $eb-font-size-xs;
			display: block;
		}
	}
}

.eb-checkbox-label,
.eb-radio-label {
	@include stack-space($eb-space-m);
	@include inset-space($eb-space-s);
	position: relative;
	cursor: pointer;
	font-weight: $eb-font-weight-semibold;
	color: $black;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	display: flex;
	width: auto;
	input {
		position: absolute;
		opacity: 0;
		cursor: pointer;
		height: 0;
		width: 0;
	}
	
	&:hover {
		background-color: $eb-color-blue-lighter;
	}
}

.eb-toggle-button {
	@include stack-space($eb-space-m);
	user-select: none;
	cursor: pointer;
	display: flex;
	align-items: center;
	width: 100%;
	font-weight: $eb-font-weight-semibold;
	color: $black;
	
	input[type="checkbox"] {
		opacity: 0;
		position: absolute;
		width: 1px;
		height: 1px;
		width: 48px;
		border: 1px solid red;
	}
	
	.eb-toggle-switch {
		display: inline-block;
		min-height: 24px;
		border-radius: $eb-radius-pill;
		width: 48px;
		background: $eb-color-gray-600;
		box-shadow: box-shadow-size(1);
		border: $eb-border-m solid transparent;
		position: relative;
		transition: all 0.25s;
		margin-right: ($eb-space-default);
		flex-shrink: 0;
		&::before,
		&::after {
			content: "";
			position: absolute;
			display: block;
			height: 20px;
			width: 20px;
			border-radius: 50%;
			left: 0;
			top: 0;
			transform: translateX(0);
			transition: all 0.25s cubic-bezier(0.5, -0.6, 0.5, 1.6);
			background: $white;
		}
		&::after {
			box-shadow: 0 0 1px $eb-color-gray-600;
		}
	}
	
	[class*="eb-toggle-label"] {
		font-weight: $eb-font-weight-semibold;
		color: $black;
	}
	
	.eb-toggle-label-left {
		margin-right: $eb-space-s;
	}
	.eb-toggle-label-right {
		margin-left: $eb-space-s;
	}
	
	.fa-check {
		position: absolute;
		top: 4px;
		left: 7px;
		z-index: $eb-zindex-default;
		font-size: 0.7rem;
		color: $white;
		opacity: 0;
	}
	
	&:focus .eb-toggle-switch,
	&:focus-within .eb-toggle-switch {
		transition: box-shadow 0.2s ease;
		outline: $eb-border-xl solid $eb-color-blue-secondary;
		border-color: $white;
	}
	
	&:hover .eb-toggle-switch {
		box-shadow: box-shadow-size(0);
	}
	
	input[disabled] {
		& ~ .eb-toggle-switch {
			background: $eb-color-gray-100;
			box-shadow: none;
			border: 1px solid $eb-color-gray-400;
			cursor: not-allowed;
			&::before,
			&::after {
				top: 1px;
			}
			& + [class*="eb-toggle-label"] {
				cursor: text;
			}
		}
	}
	
	&.active {
		.eb-toggle-switch {
			background: $eb-color-blue-secondary;
		}
		.eb-toggle-switch::after,
		.eb-toggle-switch::before {
			transform: translateX(24px);
		}
		.eb-toggle-switch::after {
			left: 0;
			background: $white;
			box-shadow: 0 0 1px $eb-color-blue-secondary;
		}
		
		.fa-check {
			opacity: 1;
		}
		
		input[disabled] ~ .eb-toggle-switch .fa-check {
			color: $eb-color-gray-400;
		}
	}
	
	@include respond-to("medium-up") {
		width: auto;
	}
}
</style>
